const API_ROOT = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
const API_BASE = `${API_ROOT}/api/operaciones-importacion`;
const CONCILIACION_API_BASE = `${API_ROOT}/api/operaciones-conciliacion`;

export const importacionOperacionesApi = {
  async analizar(formData, token) {
    return this.request(this.buildApiUrl("/analizar"), {
      method: "POST",
      headers: this.buildHeaders(token),
      body: formData,
    });
  },

  async analizarYGuardar(formData, token) {
    return this.request(this.buildApiUrl("/analizar-y-guardar"), {
      method: "POST",
      headers: this.buildHeaders(token),
      body: formData,
    });
  },

  async obtenerHistorial(token, filtros = {}) {
    const url = this.buildUrl("", token, filtros);
    return this.request(url, {
      headers: this.buildHeaders(token),
      cache: "no-store",
      debugLabel: "Historial",
    });
  },

  async obtenerImportacion(id, token) {
    return this.request(this.buildUrl(`/${id}`, token), {
      headers: this.buildHeaders(token),
      cache: "no-store",
    });
  },

  async obtenerFilas(id, token) {
    return this.request(this.buildUrl(`/${id}/filas`, token), {
      headers: this.buildHeaders(token),
      cache: "no-store",
    });
  },

  async obtenerIncidencias(id, token) {
    return this.request(this.buildUrl(`/${id}/incidencias`, token), {
      headers: this.buildHeaders(token),
      cache: "no-store",
    });
  },

  async obtenerPreconfirmacion(id, token) {
    return this.request(this.buildUrl(`/${id}/preconfirmacion`, token), {
      headers: this.buildHeaders(token),
      cache: "no-store",
    });
  },

  async confirmar(id, token, payload = { confirmacionUsuario: true }) {
    return this.request(this.buildApiUrl(`/${id}/confirmar`), {
      method: "POST",
      headers: {
        ...this.buildHeaders(token),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
  },

  async habilitarReintento(id, token) {
    return this.request(this.buildApiUrl(`/${id}/rehabilitar-reintento`), {
      method: "POST",
      headers: this.buildHeaders(token),
    });
  },

  async analizarZipFiserv(formData, token) {
    return this.request(this.buildConciliacionApiUrl("/fiserv/analizar-zip"), {
      method: "POST",
      headers: this.buildHeaders(token),
      body: formData,
    });
  },

  async obtenerDiagnosticoMapeoClover(payload, token) {
    return this.request(this.buildConciliacionApiUrl("/clover/diagnostico-mapeo"), {
      method: "POST",
      headers: {
        ...this.buildHeaders(token),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...payload, token }),
    });
  },

  async solicitarReportesClover(payload, token) {
    return this.request(this.buildConciliacionApiUrl("/clover/solicitar-reportes"), {
      method: "POST",
      headers: {
        ...this.buildHeaders(token),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...payload, token }),
    });
  },

  async conciliarFiservClover(payload, token) {
    return this.request(this.buildConciliacionApiUrl("/conciliar"), {
      method: "POST",
      headers: {
        ...this.buildHeaders(token),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...payload, token }),
    });
  },

  async obtenerHistorialConciliacion(filtros = {}, token) {
    return this.request(this.buildConciliacionApiUrl("/historial"), {
      method: "POST",
      headers: {
        ...this.buildHeaders(token),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...filtros, token }),
      cache: "no-store",
    });
  },

  async obtenerRunConciliacion(runId, filtros = {}, token) {
    return this.request(this.buildConciliacionApiUrl(`/runs/${runId}`), {
      method: "POST",
      headers: {
        ...this.buildHeaders(token),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...filtros, token }),
      cache: "no-store",
    });
  },

  async revisarResultadoConciliacion(runId, resultadoId, payload, token) {
    return this.request(this.buildConciliacionApiUrl(`/runs/${runId}/resultados/${resultadoId}/revision`), {
      method: "POST",
      headers: {
        ...this.buildHeaders(token),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...payload, token }),
    });
  },

  buildDownloadUrl(id, tipo, token) {
    return this.buildUrl(`/${id}/descargas/${tipo}`, token);
  },

  buildHeaders(token) {
    return {
      "X-CRM-Token": token || "",
    };
  },

  buildUrl(baseUrl, token, params = {}) {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        query.append(key, value);
      }
    });

    if (token) {
      query.append("token", token);
    }

    query.append("_", Date.now().toString());
    const suffix = query.toString() ? `?${query}` : "";
    return `${this.buildApiUrl(baseUrl)}${suffix}`;
  },

  buildApiUrl(path) {
    return `${API_BASE}${path}`;
  },

  buildConciliacionApiUrl(path) {
    return `${CONCILIACION_API_BASE}${path}`;
  },

  async request(url, options = {}) {
    const { debugLabel, ...fetchOptions } = options;
    const response = await fetch(url, fetchOptions);
    const contentType = response.headers.get("content-type") || "";

    if (contentType.includes("text/html")) {
      throw new Error("La API devolvio HTML en lugar de JSON. Verifique la configuracion del backend.");
    }

    const payload = await response.json().catch(() => ({}));
    if (debugLabel === "Historial") {
      console.log("Historial status", response.status);
      console.log("Historial payload", payload);
    }
    if (!response.ok) {
      throw new Error(payload?.mensaje || payload?.error || "No se pudo completar la operacion.");
    }

    return payload;
  }
};

export const importacionOperacionesApiConfig = {
  API_ROOT,
  API_BASE,
  CONCILIACION_API_BASE,
};
